import { CardColors } from "./types";

export const TOOLTIP_STYLES = {
  bgcolor: "#054254",
  color: "#fff",
  borderRadius: "10px",
  p: "12px 14px",
  maxWidth: "calc(100vw - 32px)",
  boxShadow: "0 10px 30px rgba(0,0,0,0.25)",
  fontSize: "12.5px",
  lineHeight: 1.5,
  fontWeight: 400,
  textAlign: "left",
  textTransform: "none",
  letterSpacing: "normal",
};
export const TOOLTIP_TITLE_STYLES = { fontSize: "13px", fontWeight: 600, mb: 0.5 };
export const TOOLTIP_TEXT_STYLES = { fontSize: "12.5px", lineHeight: 1.5, width: "320px" };
export const INFO_ICON_STYLES = { display: "flex", alignItems: "center", cursor: "pointer", width: 12, height: 12 };

export const CARD_COLORS: Record<string, CardColors> = {
  CAPEX: {
    border: "#334155",
    chipBg: "#F1F4F8",
    chipText: "#334155",
    value: "#334155",
    tooltipBg: "#62B3DC2E",
    tooltipText: "#BDDFF0",
  },
  ANNUAL: {
    border: "#22C55E",
    chipBg: "#F0FDF4",
    chipText: "#15803D",
    value: "#15803D",
    tooltipBg: "#81D6472E",
    tooltipText: "#D6F0B6",
  },
  PAYBACK: {
    border: "#EAB308",
    chipBg: "#FEFCE8",
    chipText: "#A16207",
    value: "#A16207",
    tooltipBg: "#81D6472E",
    tooltipText: "#D6F0B6",
  },
  KPI: {
    border: "#94A3B8",
    chipBg: "#F8FAFC",
    chipText: "#475569",
    value: "#475569",
    tooltipBg: "#81D6472E",
    tooltipText: "#D6F0B6",
  },
  "ROI (DISCOUNTED)": {
    border: "#15803D",
    chipBg: "#F0FDF4",
    chipText: "#15803D",
    value: "#15803D",
    tooltipBg: "#81D6472E",
    tooltipText: "#D6F0B6",
  },
  NPV: {
    border: "#F97316",
    chipBg: "#FFF7ED",
    chipText: "#C2410C",
    value: "#C2410C",
    tooltipBg: "#81D6472E",
    tooltipText: "#D6F0B6",
  },
  ROI: {
    border: "#15803D",
    chipBg: "#F0FDF4",
    chipText: "#15803D",
    value: "#15803D",
    tooltipBg: "#81D6472E",
    tooltipText: "#D6F0B6",
  },
  EMISSIONS: {
    border: "#0D9488",
    chipBg: "#F0FDFA",
    chipText: "#0F766E",
    value: "#0F766E",
    tooltipBg: "#0D948830",
    tooltipText: "#99F6E4",
  },
};

export const FALLBACK: CardColors = {
  border: "#334155",
  chipBg: "#F1F4F8",
  chipText: "#334155",
  value: "#334155",
  tooltipBg: "#62B3DC2E",
  tooltipText: "#BDDFF0",
};

export const CALCULATED_FALLBACK: CardColors = {
  border: "#22C55E",
  chipBg: "#F0FDF4",
  chipText: "#15803D",
  value: "#15803D",
  tooltipBg: "#81D6472E",
  tooltipText: "#D6F0B6",
};

export const FORMULA_TOOLTIP_STYLES = (colors: CardColors) => ({
  width: "fit-content",
  px: 1,
  py: 0.375,
  borderRadius: "6px",
  backgroundColor: "rgba(255,255,255,0.12)",
  border: `1px solid ${colors.chipBg}50`,
  fontSize: "11px",
  fontWeight: 500,
  color: `${colors.tooltipText}`,
  letterSpacing: "0.03em",
});

export const CHIP_TOOLTIP_STYLES = (colors: CardColors) => ({
  width: "fit-content",
  px: 1,
  py: 0.375,
  borderRadius: 3,
  backgroundColor: `${colors.tooltipBg}`,
  fontSize: "11px",
  fontWeight: 600,
  color: `${colors.tooltipText}`,
  letterSpacing: "0.03em",
});

export const CARD_CONTAINER_STYLES = (colors: CardColors) => ({
  backgroundColor: "white",
  borderRadius: "8px",
  borderLeft: `4px solid ${colors.border}`,
  boxShadow: "0px 2px 12px rgba(0,0,0,0.2)",
  p: 2.5,
  display: "flex",
  flexDirection: "column",
  gap: 1.5,
  transition: "transform 0.25s ease, box-shadow 0.25s ease",
  "&:hover": {
    transform: "translateY(-3px)",
    boxShadow: "0 12px 28px rgba(0,0,0,0.1), 0 2px 6px rgba(0,0,0,0.06)",
  },
});

export const BADGE_BOX_STYLES = (colors: CardColors) => ({
  display: "inline-flex",
  alignItems: "center",
  gap: 0.75,
  px: 1.25,
  py: 0.625,
  backgroundColor: colors.chipBg,
  borderRadius: "4px",
  width: "fit-content",
});

export const BADGE_ICON_STYLES = (colors: CardColors) => ({
  width: 12,
  height: 12,
  display: "flex",
  alignItems: "center",
  flexShrink: 0,
  color: colors.chipText,
  "& svg": { color: colors.chipText },
  "& svg path": { fill: colors.chipText },
});

export const BADGE_TEXT_STYLES = (colors: CardColors) => ({
  fontSize: "10px",
  fontWeight: 600,
  color: colors.chipText,
  letterSpacing: "0.07em",
  textTransform: "uppercase",
  lineHeight: 1,
});

export const VALUE_STYLES = (colors: CardColors, isError: boolean) => ({
  fontSize: "28px",
  fontWeight: 700,
  color: isError ? "error.main" : colors.value,
  lineHeight: 1.1,
  letterSpacing: "-0.02em",
  fontVariantNumeric: "tabular-nums",
});

export const SUBTITLE_STYLES = {
  fontSize: "12px",
  color: "#6B7280",
  fontWeight: 400,
  display: "flex",
  alignItems: "center",
  gap: 1,
};
